import kr from './kr';
import en from './en';
import jp from './jp';
import zh from './zh';

export default {
  kr,
  en: Object.assign(Object.assign({}, kr), en),
  jp: Object.assign(Object.assign({}, kr), jp),
  zh: Object.assign(Object.assign({}, kr), zh)
};
